import { env } from "@/env";
import slug from "slug";


export const generateCollectionURL = ({ title, id, page, host = env.NEXT_PUBLIC_BASE_URL }: { title: string, id : string, page?: number, host?: string }) => {
  return `${host}/shop/kollektionen/${slug(title)}-${id}${page ? `?page=${page}` : ""}`;
}

export const generateServerSideCollectionURL = ({ title, id, page }: { title: string, id : string, page?: number }) => {
  return `${env.NEXT_PUBLIC_BASE_URL}/shop/kollektionen/${slug(title)}-${id}${page ? `?page=${page}` : ""}`;
}

export const generateProductURL = ({ title, id, host = env.NEXT_PUBLIC_BASE_URL  }: { title: string, id : string, host?: string }) => {
  return `${host}/shop/produkte/${slug(title)}-${id}`;
}

export const generateServerSideProductURL = ({ title, id }: { title: string, id : string }) => {
  return `${env.NEXT_PUBLIC_BASE_URL}/shop/produkte/${slug(title)}-${id}`;
}

export const getCollectionIdFromURL = (url?: string|null) => {
  if (!url) return null;
  const parts = url.split("/");
  // if page is included in the url, remove it
  if (parts[parts.length - 1]?.includes("?page")) {
    parts.pop();
  }

  const lastPart = parts[parts.length - 1];

  return lastPart?.split("-").reverse()[0];
}

export const getProductIdFromURL = (url?: string|null) => {
  if (!url) return null;
  const parts = url.split("/");

  const lastPart = parts[parts.length - 1];

  return lastPart?.split("-").reverse()[0];
}